import { RequestQueryParamsModel } from "../http.interface";

export class WarehouseListParams implements RequestQueryParamsModel {
  limit?: number;
  page?: number;
  search?: string;
  sorts?: string;
  byUser?: boolean;
}
